import Tooltip from '@components/Tooltip/Tooltip';
import { faLock } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { classNames } from '@modules/classname-helpers';
import type { FC } from 'react';

import styles from './EmailSignatureLockLayer.module.scss';

type EmailSignatureLockLayerProps = {
  message: string;
};

const EmailSignatureLockLayer: FC<React.PropsWithChildren<EmailSignatureLockLayerProps>> = ({ message }) => {
  return (
    <div className={classNames(styles['lock-layer'])}>
      <div className={styles['lock-message-container']}>
        <Tooltip size="small" label={message} aria-label="lock explanation message">
          <div className={styles['lock-message-wrapper']}>
            <div className={styles['lock-message']}>LOCKED</div>
            <FontAwesomeIcon icon={faLock} />
          </div>
        </Tooltip>
      </div>
    </div>
  );
};

type EmailSignatureLockLayerForInputProps = {
  message: string;
};

const EmailSignatureLockLayerForInput: FC<React.PropsWithChildren<EmailSignatureLockLayerForInputProps>> = ({
  message,
}) => {
  return (
    <div className={styles['lock-layer-for-input']}>
      <Tooltip size="small" label={message} aria-label="lock explaination message">
        <div className={styles['lock-message-container']}>
          <p className={styles['lock-message']}>LOCKED</p>
          <FontAwesomeIcon icon={faLock} />
        </div>
      </Tooltip>
    </div>
  );
};

export default EmailSignatureLockLayer;

export { EmailSignatureLockLayerForInput };
